import { ConsumableLifetimeCycleThemeSizeConfig } from './types';

const large: ConsumableLifetimeCycleThemeSizeConfig = {
  consumableLifetimeCycle: {},
};

export default large;
